var COLOR;
(function (COLOR) {
    COLOR["TEXT"] = "text";
    COLOR["BACKGROUND"] = "background";
    COLOR["PRIMARY"] = "primary";
    COLOR["SECONDARY"] = "secondary";
})(COLOR || (COLOR = {}));
export default COLOR;
